module.exports = __webpack_public_path__ + "media/icons/phone-9ee37841.png";